import * as React from 'react';
import { QrCode } from '../modules/PaymentMethodsList/modules/QrCode/layout/QrCode.js';

const useRenderQrForm = ()=>{
    const renderQrForm = React.useCallback(({ paymentFlow , paymentMethodType , logoUrl , orderId , paymentResponse , orderToken , handleRefreshQrCode , cart , refetch , selfUrl ,  })=>{
        return /*#__PURE__*/ React.createElement(QrCode, {
            logoSettings: {
                alt: paymentMethodType,
                url: logoUrl
            },
            paymentMethodType: paymentMethodType,
            orderId: orderId,
            paymentResponse: paymentResponse,
            paymentFlow: paymentFlow,
            orderToken: orderToken,
            onQrCodeRefresh: handleRefreshQrCode,
            selfUrl: selfUrl,
            refetch: refetch,
            cart: cart
        });
    }, []);
    return React.useMemo(()=>[
            renderQrForm
        ]
    , [
        renderQrForm
    ]);
};

export { useRenderQrForm };
//# sourceMappingURL=use-render-qr-form.js.map
